import axios from "axios";
import OSS from "ali-oss";
import {
  Notification,
  Loading
} from "element-ui";
import store from "@/vuex";
import {
  dateToFormat
} from "@/config/_filter"

let loadingInstance; // loading组件

function getRepairFileName(file) {
  return `${Math.floor(Math.random() * 100000 + 1)}-${file.name}`;
}

const multipartUpload = function (path, files, client) {


  if (!path)
    path = 'public/' + dateToFormat();

  return new Promise(function (resolve, reject) {
    const name = getRepairFileName(files);
    client

      .multipartUpload('static/' + path + "/" + name, files.raw, {})

      .then(result => {
        resolve({
          name: result.name,
          url: "https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/" + result.name,
          length: Math.ceil(files.size / 1024) + "KB"
        });
      })
      .catch(err => {
        Notification({
          title: "警告",
          message: `${files.name}上传失败,请重试`,
          type: "warning"
        });
        reject(err);
      });
  });
};
// compress:是否压缩
const uploadFile = async function (file, path, compress = false) {
  let files = Array.isArray(file) ? file : Array.of(file);
  if (!files.length) throw new Error("请添加文件");
  let flag = false;
  let client;
  let fileList = [];
  loadingInstance = Loading.service({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  await axios.get('/api/get/aliyun/sts', {
    headers: {
      "Authorization": location.pathname.includes("/background/") ? store.getters.adminToken : store.getters.token,
      "X-Requested-With": "XMLHttpRequest"
    }
  }).then(res => {
    client = new OSS({
      region: "oss-cn-zhangjiakou",
      accessKeyId: res.data.AccessKeyId,
      accessKeySecret: res.data.AccessKeySecret,
      stsToken: res.data.SecurityToken,
      bucket: 'steamfun',
      secure: true
    });
    flag = true;
  })
    .catch(err => {
      Notification({
        title: "警告",
        message: err,
        type: "warning"
      });
      loadingInstance.close();
      return new Promise(function (resolve, reject) {
        reject(new Error("获取token失败"));
      });
    });
  if (flag) {
    for (let i = 0; i < files.length; i++) {
      if (files[i].raw) {
        let file = files[i]
        console.log('file:', file)
        if (compress) {
          const base64Codes = await compressUpload(file.raw, {})
          const bl = convertBase64UrlToBlob(base64Codes)
          console.log('bl:', bl)
          file.size = bl.size;
          file.raw = bl;
        }
        await multipartUpload(path, file, client)
          .then(res => {
            console.log(res)
            fileList.push(res);
          })
          .catch(err => {
            console.log(err)
          });
      } else {
        fileList.push(files[i]);
      }
    }
    loadingInstance.close();
    return new Promise(function (resolve) {
      resolve(fileList);
    });
  }
};

/*
    三个参数
    file：一个是文件(类型是图片格式)，
    w：一个是文件压缩的后宽度，宽度越小，字节越小
    compressUpload()
    */
function compressUpload(file, w) {
  return new Promise((resolve => {
    var ready = new FileReader();
    /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
    ready.readAsDataURL(file);
    ready.onload = function () {
      var re = this.result;
      resolve(canvasDataURL(re, w))
    }
  }))
}
//重新绘制图片
function canvasDataURL(path, obj) {
  return new Promise((resolve => {
    var img = new Image();
    img.src = path;
    img.onload = function () {
      var that = this;
      // 默认按比例压缩
      var w = that.width,
        h = that.height,
        scale = w / h;
      w = obj.width || w;
      h = obj.height || (w / scale);
      var quality = 0.7;  // 默认图片质量为0.7
      //生成canvas
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      // 创建属性节点
      var anw = document.createAttribute("width");
      anw.nodeValue = w;
      var anh = document.createAttribute("height");
      anh.nodeValue = h;
      canvas.setAttributeNode(anw);
      canvas.setAttributeNode(anh);
      ctx.drawImage(that, 0, 0, w, h);
      // 图像质量
      if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
        quality = obj.quality;
      }
      // quality值越小，所绘制出的图像越模糊
      var base64 = canvas.toDataURL('image/jpeg', quality);
      // 回调函数返回base64的值
      resolve(base64);
    }
  }))
}
/**
 * 将以base64的图片url数据转换为Blob
 * @param urlData
 *            用url方式表示的base64图片数据
 */
function convertBase64UrlToBlob(urlData) {
  var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export default uploadFile;